<script setup>
import { ref, onMounted, watch, defineExpose } from "vue"
import i18n from "@/i18n"
import { dateFormat1 } from "@/utils/common.js";
import { useRouter } from "vue-router";
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import Swal from "sweetalert2";
import { getProductTemplateList, deleteProductTemplate, putProductTemplateStatus, copyProductTemplate } from "@/service"
import store from "@/state/store";
import { getLangValue } from "@/utils/common"; //获取后端语言
const tableInfo = ref([]) // 表格数据
const router = useRouter()
const table_head = [
    // getLangValue("attribute.number"),
    getLangValue("product-template.productTemplateName1"),
    // getLangValue("product-template.hscodeDatabase"),
    'HS Code',
    'HS Code'+ getLangValue("product-template.description"),
    getLangValue("product-template.targetmarket"),
    getLangValue("attribute.create_time"),
    getLangValue("product-template.update_time"),
    getLangValue("base.operation"),
]
const pageSizeOption = [10, 20, 30, 40, 50]
// const loading = ref(false)
const { total, currentPage, pageSize, pageOption } = usetablePageNation()
const formValidataAlert = ref(false)
const loading = ref(false)  // 加载效果
const alertInfo = ref({
    variant: "danger",
    content: "",
    icon: "ri-error-warning-line",
})
const iconObj = {
    danger: "ri-error-warning-line",
    success: "ri-check-line",
    warning: "ri-error-warning-line",
    info: "ri-information-line",
}
const openAlert = (info, time = 3000) => {
    formValidataAlert.value = false;
    if (info.content) {
        alertInfo.value.content = info.content;
        alertInfo.value.icon = iconObj[info.variant] ? iconObj[info.variant] : 'ri-check-line';
        alertInfo.value.variant = info.variant;
        formValidataAlert.value = true;
    }
    setTimeout(
        () => {
            formValidataAlert.value = false;
        },
        time
    );
}
// const templateName = ref("")
const searchData = ref({
    hscode: '',
    templateName: '',
    date: '',
})
const switchChange = async ({ id, enabled }) => {
    //切换开关
    // console.log(enabled);
    let params = {
        status: enabled ? 1 : 0
    }
    if (params.status == 0) {
        Swal.fire({
            title: getLangValue("base.alert_message_info"),
            text: getLangValue("product-template.warningInfo"),
            icon: "warning",
            showCancelButton: true,
            cancelButtonColor: "#f46a6a",
            confirmButtonColor: "#34c38f",
            confirmButtonText: getLangValue("base.done"),
            cancelButtonText: getLangValue("base.cancel"),
        }).then(async (result) => {
            if (result.isConfirmed) {
                const resp = await putProductTemplateStatus(id, params)
                if (resp) {
                    openAlert({
                        variant: resp.code == 1 ? "danger" : 'success',
                        content: resp.code == 1 ? resp.message : getLangValue("base.edit_success"),
                    });
                    getDataList();
                    if (resp.code == 0) {
                        store.commit('ft/setupdateTemplate', new Date().getTime())
                        // sessionStorage.setItem('updateTemplate', new Date().getTime())
                    }
                }
            } else {
                getDataList();
            }
        });
    } else {
        const resp = await putProductTemplateStatus(id, params)
        if (resp) {
            openAlert({
                variant: resp.code == 1 ? "danger" : 'success',
                content: resp.code == 1 ? resp.message : getLangValue("base.edit_success"),
            });
            getDataList();
            if (resp.code == 0) {
                store.commit('ft/setupdateTemplate', new Date().getTime())
                // sessionStorage.setItem('updateTemplate', new Date().getTime())
            }
        }
    }


}

const handler = (type, info) => {
    //按钮处理
    let url;
    switch (type) {
        case 'view':
            url = router.resolve({ name: 'product_template_detail', query: { type: 'view', id: info.id } }).href
            window.open(url, "_blank")
            break;
        case 'edit':
            url = router.resolve({ name: 'product_template_detail', query: { type: 'edit', id: info.id } }).href
            window.open(url, "_blank")
            break;
        case 'copy':
            copyData(info)
            break;
        case 'delete':
            deleteData(info)
            break;
    }
}

const copyData = async ({ id }) => {
    //复制
    // console.log(id);
    let params = {
        database_template_id: id
    }
    const resp = await copyProductTemplate(params)
    if (resp) {
        openAlert({
            variant: resp.code == 1 ? "danger" : 'success',
            content: resp.code == 1 ? resp.message : getLangValue("base.copy_success"),
        });
        //  更新
        if (resp.code == 0) {
            getDataList();
            // window.location.reload();
        }
    }
}

const deleteData = async ({ id }) => {
    Swal.fire({
        title: getLangValue("product-template.deleteTitle"),
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            // console.log(id)
            //延迟2s操作
            let resp = await deleteProductTemplate(id);
            if (resp) {
                openAlert({
                    variant: resp.code == 1 ? "danger" : 'success',
                    content: resp.code == 1 ? resp.message : getLangValue("base.delete_success"),
                });
                //  更新
                if (resp.code == 0) {
                    getDataList();
                    window.location.reload();
                }

            }
        }
    });
}

const getDataList = async () => {
    // console.log(searchData.value.date);
    // loading.value = true
    // let arr = searchData.value.date == null || !searchData.value.date ? [] : searchData.value.date.replaceAll(' ', '').split('to')
    // console.log(arr);
    loading.value = true
    //获取数据
    let params = {
        page: currentPage.value - 1,
        limit: pageSize.value,
        template_name: searchData.value.templateName,
        keyword: searchData.value.hscode,
        create_time: searchData.value.date == null  || !searchData.value.date ? "" : JSON.stringify(searchData.value.date),
        order_by: 'desc',
        sort_field: 'create_time',
    }
    const resp = await getProductTemplateList(params);
    // loading.value = false
    loading.value = false
    if (resp.code == 0) {
        // console.log((currentPage.value - 1) * pageSize.value);
        if (resp.payload.total == (currentPage.value - 1) * pageSize.value && currentPage.value > 1) {
            currentPage.value--
            // console.log(111);
            return
        }
        resp.payload.data.forEach(element => {
            element.enabled = element.status == 1 ? true : false
        });
        tableInfo.value = resp.payload.data;
        total.value = resp.payload.total
        // setPages();
        // setdata();

    }

}

// const setPages = () => {
//     pageOption.value = [];
//     let numberOfPages = Math.ceil(total.value / pageSize.value);
//     for (let index = 1; index <= numberOfPages; index++) {
//         pageOption.value.push(index);
//     }
// }

// const setdata = () => {
//     tableData.value = tableInfo.value.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value)
// }

watch(pageSize, () => {
    currentPage.value = 1;
    getDataList();
    // setdata();
    // setdata()
})

watch(currentPage, () => {
    getDataList();
    // setdata()
})

watch(searchData, () => {
    currentPage.value = 1;
    getDataList();
}, { deep: true })

onMounted(() => {
    getDataList()
})
//弹出
defineExpose({
    // templateName,
    searchData
})
</script>

<template>
    <div class="form px-3 py-1" style="height: 100%;" v-loading="loading">
        <!-- Bordered Tables -->
        <div style="height:calc(100% - 50px); overflow-y: auto;" class="my-scroll-bar" v-if="tableInfo.length">
            <table class="table table-bordered table-nowrap mb-0" >
                <thead class="table-light">
                    <tr>
                        <th scope="col" v-for="(head, index) in table_head" :key="index" style="color: #878A99;"
                            width="20%">
                            {{ head }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(info, index) in tableInfo" :key="index" style="vertical-align: middle">
                        <td>{{ i18n.global.locale == 'en'? info.name_en : info.name }}</td>
                        <td>{{ i18n.global.locale == 'en'?  info.hscode?.title_en : info.hscode?.title }}</td>
                        <td style="max-width: 300px; word-wrap: break-word; white-space: normal;" 
                        :class="i18n.global.locale == 'en' ? 'en-word-break' : 'zh-word-break'">
                        {{   i18n.global.locale == 'en'? info.hscode?.description_en : info.hscode?.description }}
                    
                        </td>
                        <td>{{  i18n.global.locale == 'en'? info.destination_market?.title_en : info.destination_market?.title}}
                        </td>
                        <td>{{ info.create_time ? dateFormat1(info.create_time) : '' }}</td>
                        <td>{{ info.update_time ? dateFormat1(info.update_time) : '' }}</td>
                        <td>
                            <ul class="list-inline hstack gap-2 mb-0" style="min-height: 40px;">
                                <li class="mx-2" v-permit="'product-template.modify'">
                                    <b-form-checkbox v-model="info.enabled" switch
                                        @change="switchChange(info)"></b-form-checkbox>
                                </li>
                                <li class="list-inline-item cursor" v-permit="'product-template.show'">
                                    <div class="text-primary d-inline-block" @click="handler('view', info)">
                                        <i class="fs-16 ri-eye-fill"></i>
                                    </div>
                                </li>
                                <li  v-permit="'product-template.modify'"  class="list-inline-item cursor">
                                    <div  v-if="info.status === 0" class="text-primary d-inline-block" @click="handler('edit', info)">
                                        <i class="fs-16 ri-pencil-fill"></i>
                                    </div>
                                </li>
                                <li class="list-inline-item cursor" v-permit="'product-template.add'">
                                    <div class="text-primary d-inline-block" @click="handler('copy', info)">
                                        <i class="fs-16 bx bx-copy" style="transform: rotate(90deg); color:black"></i>
                                    </div>
                                </li>
                                <li v-permit="'product-template.delete'"  class="list-inline-item" title="delete"
                                   >
                                    <div  v-if="info.status === 0"   class="d-inline-block text-danger cursor" @click="handler('delete', info)">
                                        <i class="fs-16 ri-delete-bin-5-fill"></i>
                                    </div>
                                </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div style="height:calc(100% - 50px); overflow-y: auto;" class="my-scroll-bar d-flex align-items-center justify-content-center" v-else>
            <Empty  style="margin-top: 200px;"></Empty>
        </div>
        <!-- 分页 -->
        <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
            :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5 mt-0" style="margin-top: 0 !important;">
        </Pagination>
    </div>
    <message-alert :alertInfo="alertInfo" v-if="formValidataAlert"></message-alert>
</template>
<style scoped>
.table-bordered> :not(caption)>*>* {
    border: unset;
}
.table-bordered td {
    border: unset;
    padding: 0.25rem 0.6rem !important;
    /* padding: 0.2rem 0.6rem; */
}
</style>